export const MuiPaper = {
  styleOverrides: {
    root: {
      borderRadius: '10px',
    },
  },
};
